import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { font } from "../tokens";

// Botão flutuante "Agende uma demo" (referência: pipefy.com).
// Fixo no canto inferior direito, acima do WhatsApp. Aparece com fade/slide
// quando o usuário passa da primeira dobra (~90% da altura da viewport).
export default function DemoFloat() {
  const [show, setShow] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Link
      to="/agendar-demo"
      className="demo-float"
      aria-label="Agende uma demonstração"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "fixed",
        right: 0,
        top: "50%",
        zIndex: 95,
        display: "inline-flex",
        alignItems: "center",
        gap: 12,
        padding: "6px 22px 6px 6px",
        borderRadius: "999px 0 0 999px",
        background: "linear-gradient(90deg, #0560FF 0%, #0A47D8 100%)",
        color: "#fff",
        textDecoration: "none",
        fontFamily: font,
        fontSize: 15.5,
        fontWeight: 700,
        letterSpacing: -0.1,
        whiteSpace: "nowrap",
        boxShadow: hover
          ? "0 10px 30px rgba(5,96,255,0.45)"
          : "0 6px 20px rgba(5,96,255,0.32)",
        opacity: show ? 1 : 0,
        transform: show ? "translateY(-50%)" : "translate(100%, -50%)",
        pointerEvents: show ? "auto" : "none",
        transition:
          "opacity 0.4s ease, transform 0.5s cubic-bezier(.16,1,.3,1), box-shadow 0.2s",
      }}
    >
      <span
        style={{
          width: 42,
          height: 42,
          borderRadius: "50%",
          flexShrink: 0,
          background: "#0A2A6B",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.12)",
        }}
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="4" width="20" height="13" rx="2" />
          <path d="M8 21h8M12 17v4" />
          <path d="M10.2 8.4 14 11l-3.8 2.6z" fill="#fff" stroke="none" />
        </svg>
      </span>
      Agendar Demonstração
    </Link>
  );
}
